import { render, staticRenderFns } from "./GalleryModule.vue?vue&type=template&id=5406714e&scoped=true"
import script from "./GalleryModule.vue?vue&type=script&lang=js"
export * from "./GalleryModule.vue?vue&type=script&lang=js"
import style0 from "./GalleryModule.vue?vue&type=style&index=0&id=5406714e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5406714e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/GalleryModule.vue
// module id = 343
// module chunks = 0